"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatContactDTO = exports.MessagesDTO = exports.ContactDTO = exports.UnreadCountDTO = exports.BaseDTO = void 0;
class BaseDTO {
    id;
}
exports.BaseDTO = BaseDTO;
class UnreadCountDTO {
    unreadCount;
}
exports.UnreadCountDTO = UnreadCountDTO;
class ContactDTO extends UnreadCountDTO {
    id;
    name;
    avatar;
    lastMessage;
    createdAt;
}
exports.ContactDTO = ContactDTO;
class MessagesDTO extends BaseDTO {
    content;
    createdAt;
    type;
    status;
    isOwn;
}
exports.MessagesDTO = MessagesDTO;
class ChatContactDTO extends ContactDTO {
    messages;
}
exports.ChatContactDTO = ChatContactDTO;
